import MutationApi from '../remote/mutationApi'
const GENERIC_ERROR_MESSAGE = 'Failed to adjust price'

export const updateLineItems = async (orderUuid, orderMenuItems) => {
  const result = await MutationApi.updateLineItems(orderUuid, orderMenuItems)
  const applied = result?.data?.orderMutations?.[0]?.applied

  if (result?.status !== 201) {
    throw new Error(GENERIC_ERROR_MESSAGE)
  }

  if (!applied) {
    throw new Error(result?.data?.orderMutations?.[0]?.friendlyMessage || GENERIC_ERROR_MESSAGE)
  }

  return result
}
